import PieChart from "../../../../../components/pieChart/pieChart";
import {connect} from "react-redux";

export default connect(state => ({
  data: [
    ["Intros Purchased", state.conversionInfo.introsPurchased],
    [`Didn't Purchase`, state.conversionInfo.notPurchased]
  ],
  showLegend: true
}))(PieChart);
